const TeachersClassesSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 h-full w-full animate-pulse">
      {/* Header Skeleton */}
      <div className="w-48 h-8 bg-neutral-200 rounded-md " />

      {/* Tabs Skeleton */}
      <div className="flex gap-4 border-b border-neutral-200  pb-2">
        <div className="w-24 h-8 bg-neutral-200 rounded-md " />
        <div className="w-24 h-8 bg-neutral-200 rounded-md " />
      </div>

      {/* Search & Button Skeleton */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="w-72 h-10 bg-neutral-200 rounded-md " />
        <div className="w-32 h-10 bg-neutral-200 rounded-md " />
      </div>

      {/* Overview Title */}
      <div className="w-36 h-6 bg-neutral-200 rounded-md " />
    </div>
  );
};

export default TeachersClassesSkeleton;
